import { render } from "./used-group.vue?vue&type=template&id=13d8fee2&scoped=true&ts=true"
import script from "./used-group.vue?vue&type=script&lang=ts"
export * from "./used-group.vue?vue&type=script&lang=ts"

import "./used-group.vue?vue&type=style&index=0&id=13d8fee2&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d8fee2"]])

export default __exports__